<script setup lang="ts">
import { gradeLabel } from '@/util/gradesort'

const props = defineProps<{ grades: string[], selected: string[], labelledBy: string }>()
const emit = defineEmits<{ 'update:selected': [grades: string[]] }>()

function isSelected(grade: string) {
  return props.selected.includes(grade)
}

function toggle(grade: string) {
  const selectedOrder = isSelected(grade) ? props.selected.filter((chosen) => chosen !== grade) : [...props.selected, grade]
  emit('update:selected', props.grades.filter((offered) => selectedOrder.includes(offered)))
}
</script>

<template>
  <div role="group" :aria-labelledby="labelledBy" class="flex flex-wrap gap-x-1.5 gap-y-2">
    <label
      v-for="grade in grades"
      :key="grade"
      :for="`assessment-grade-${grade}`"
      class="mb-[5px] flex h-8 cursor-default items-center gap-2 whitespace-nowrap rounded-lg border px-3 py-1 text-sm leading-4 text-gray-1000 has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-blue-400"
      :class="isSelected(grade) ? 'border-blue-400 bg-blue-200 hover:border-gray-700 hover:bg-blue-300' : 'border-gray-700 bg-gray-50 hover:bg-gray-200'"
    >
      <input
        :id="`assessment-grade-${grade}`"
        class="sr-only"
        type="checkbox"
        :checked="isSelected(grade)"
        :value="grade"
        :aria-label="gradeLabel(grade)"
        @change="toggle(grade)"
      >
      <span v-if="isSelected(grade)" class="material-icons-outlined text-lg leading-4" aria-hidden="true">done</span>
      {{ gradeLabel(grade) }}
    </label>
  </div>
</template>
